<template>
  <div class="clause">
    <h2>{{header}}</h2>
    <div>{{time}}</div>
    <div class="wl">
      <h3>{{qy}}</h3>
      <h4
        v-for="(item,index) in list"
        :key="index"
      >
        {{item.name}}
      </h4>
      <!-- 一、 -->
      <h4>{{one}}</h4>
      <p
        v-for="(item,i) in oneList"
        :key="i"
      >
        {{item.name}}
      </p>
      <!-- 二、 -->
      <h4>{{two}}</h4>
      <h4>{{numone}}</h4>
      <p
        v-for="(item,i) in numoneList"
        :key="i"
      >
        {{item.name}}
      </p>
      <h4>{{numtwo}}</h4>
      <p
        v-for="(item,i) in numtwoList"
        :key="i"
      >
        {{item.name}}
      </p>

      <h4>{{numthree}}</h4>
      <p
        v-for="(item,i) in numthreeList"
        :key="i"
      >
        {{item.name}}
      </p>
      <!-- 三、 -->
      <h4>{{three}}</h4>
      <h4>{{three_one}}</h4>
      <p
        v-for="(item,i) in three_one_list"
        :key="i"
      >
        {{item.name}}
      </p>
      <h4>{{three_two}}</h4>
      <p
        v-for="(item,i) in three_two_list"
        :key="i"
      >
        {{item.name}}
      </p>
      <h4>{{three_three}}</h4>
      <p
        v-for="(item,i) in three_three_list"
        :key="i"
      >
        {{item.name}}
      </p>
      <!-- 四 -->
      <h4>{{four}}</h4>
      <h4>
        {{four_one}}
      </h4>
      <h4>
        {{four_two}}
      </h4>
      <p
        v-for="(item,i) in four_one_list"
        :key="i"
      >
        {{item.name}}
      </p>
      <p
        v-for="(item,m) in four_one_text"
        :key="m"
      >
        {{item.name}}
      </p>
      <!-- 五、 -->
      <h3>{{five}}</h3>
      <p
        v-for="(item,m) in five_list"
        :key="m"
      >
        {{item.name}}
      </p>
      <!-- 六、 -->
      <h3>
        {{six}}
      </h3>
      <p
        v-for="(item,m) in six_list"
        :key="m"
      >
        {{item.name}}
      </p>
      <h3>{{seven}}</h3>
      <p
        v-for="(item,m) in seven_list"
        :key="m"
      >
        {{item.name}}
      </p>
      <h3>{{eight}}</h3>
      <p
        v-for="(item,m) in eight_list"
        :key="m"
      >
        {{item.name}}
      </p>
      <h3>{{nine}}</h3>
      <p
        v-for="(item,m) in nine_list"
        :key="m"
      >
        {{item.name}}
      </p>
      <h3>{{ten}}</h3>
      <p
        v-for="(item,m) in ten_list"
        :key="m"
      >
        {{item.name}}
      </p>
      <h3>{{eleven}}</h3>
      <p
        v-for="(item,m) in eleven_list"
        :key="m"
      >
        {{item.name}}
      </p>
      <h3>{{twelve}}</h3>
      <p
        v-for="(item,m) in twelve_list"
        :key="m"
      >
        {{item.name}}
      </p>
      <h3>{{thirteen}}</h3>
      <p
        v-for="(item,m) in thirteen_list"
        :key="m"
      >
        {{item.name}}
      </p>
      <h3>{{fourteen}}</h3>
      <p
        v-for="(item,m) in fourteen_list"
        :key="m"
      >
        {{item.name}}
      </p>
      <h3>{{fifteen}}</h3>
      <p
        v-for="(item,m) in fifteen_list"
        :key="m"
      >
        {{item.name}}
      </p>
      <br>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      header: this.$t('clause.header'),
      time: this.$t('clause.time'),
      qy: this.$t('clause.qy'),
      list: this.$t('clause.list'),
      one: this.$t('clause.one'),
      oneList: this.$t('clause.oneList'),
      two: this.$t('clause.two'),
      numone: this.$t('clause.numone'),
      numoneList: this.$t('clause.numoneList'),
      numtwo: this.$t('clause.numtwo'),
      numtwoList: this.$t('clause.numtwoList'),
      numthree: this.$t('clause.numthree'),
      numthreeList: this.$t('clause.numthreeList'),
      // 三、
      three: this.$t('clause.three'),
      three_one: this.$t('clause.three_one'),
      three_one_list: this.$t('clause.three_one_list'),
      three_two: this.$t('clause.three_two'),
      three_two_list: this.$t('clause.three_two_list'),
      three_three: this.$t('clause.three_three'),
      three_three_list: this.$t('clause.three_three_list'),
      four: this.$t('clause.four'),
      four_one:this.$t('clause.four_one'),
      four_two: this.$t('clause.four_two'),
      four_one_text:this.$t('clause.four_one_text'),
      four_one_list: this.$t('clause.four_one_list'),
      four_one_text: this.$t('clause.four_one_text'),
      // 五、
      five: this.$t('clause.five'),
      five_list: this.$t('clause.five_list'),
      // 六、
      six:this.$t('clause.six'),
      six_list: this.$t('clause.six_list'),
      seven: this.$t('clause.seven'),
      seven_list: this.$t('clause.seven_list'),
      eight: this.$t('clause.eight'),
      eight_list: this.$t('clause.eight_list'),
      nine:this.$t('clause.nine'),
      nine_list:this.$t('clause.nine_list'),
      ten: this.$t('clause.ten'),
      ten_list:this.$t('clause.ten_list'),
      eleven: this.$t('clause.eleven'),
      eleven_list: this.$t('clause.eleven_list'),
      twelve: this.$t('clause.twelve'),
      twelve_list:this.$t('clause.twelve_list'),
      thirteen: this.$t('clause.thirteen'),
      thirteen_list:this.$t('clause.thirteen_list'),
      fourteen: this.$t('clause.fourteen'),
      fourteen_list: this.$t('clause.fourteen_list'),
      fifteen:this.$t('clause.fifteen'),
      fifteen_list: this.$t('clause.fifteen_list'),
    };
  }
};
</script>
<style lang="scss" scoped>
.clause {
  padding: 0 40px;
  h2 {
    font-weight: 700;
  }
  p {
    line-height: 1.6;
    margin-left: 10px;
  }
}
</style>
